import { render, staticRenderFns } from "./TabelaSelecionaEndereco.vue?vue&type=template&id=70dd1d8f"
import script from "./TabelaSelecionaEndereco.vue?vue&type=script&lang=js"
export * from "./TabelaSelecionaEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports